import React from 'react'

import {isEqual} from 'es-toolkit'
import {isEmpty} from 'es-toolkit/compat'
import {FormikProps} from 'formik'

import useKeyPress from '../../../commons/src/hooks/use-key-press'
import preventDoubleClick from '../../../commons/src/services/prevent-double-click'

import checkedIcon from '../../../commons/src/assets/icons/checked.svg'

import Button from '../../../commons/src/components/button'
import Icon from '../../../commons/src/components/icon'
import LoadingIndicator from '../../../commons/src/components/loading-indicator'

type Props<Values> = {
  formik: FormikProps<Values>
  isSubmitted?: boolean
  icon?: React.ReactElement
  iconAlign?: 'left' | 'right'
  label?: string
  doneLabel?: string
  submitOnEnter?: boolean
  disabled?: boolean
}

const SaveButtonPartial = <Values,>({
  formik,
  isSubmitted = false,
  icon,
  iconAlign = 'left',
  label = 'Save',
  doneLabel = 'Saved',
  submitOnEnter = true,
  disabled = false,
}: Props<Values>) => {
  const hasChanges = !isEqual(formik.initialValues, formik.values)
  const hasErrors = formik.submitCount > 0 && !isEmpty(formik.errors)
  const isSaved = isSubmitted && !hasChanges

  useKeyPress(
    preventDoubleClick(() => formik.handleSubmit()),
    'Enter',
    submitOnEnter
  )

  return (
    <Button
      disabled={formik.isSubmitting || !hasChanges || hasErrors || disabled}
      icon={
        isSaved ? (
          <Icon source={checkedIcon} />
        ) : formik.isSubmitting && !hasErrors ? (
          <LoadingIndicator invert />
        ) : (
          icon
        )
      }
      iconAlign={iconAlign}
      onClick={preventDoubleClick(() => formik.handleSubmit())}
    >
      {isSaved ? doneLabel : label}
    </Button>
  )
}

export default SaveButtonPartial
